// extracted by mini-css-extract-plugin
export var videoCard = "video-card-module--videoCard--3kN0P";
export var inner = "video-card-module--inner--2wBfV";
export var videoTitle = "video-card-module--videoTitle--10Jux";
export var videoContainer = "video-card-module--videoContainer--3dMjW";